<template>
  <v-flex xs12 pt-0 mt-1 style="cursor: pointer" @click.prevent="toogleView">
    <v-layout row wrap>
      <v-flex xs12 py-0>
        <v-container py-3 px-0>
          <v-layout row wrap>
            <v-flex xs6>
              <v-layout row wrap body-1>
                <v-flex xs12 py-0>
                  {{receiverName(record.receiver)}}
                  <span v-if="record.from_chargeback" class="color-light-red font-weight-bold uppercase">MED</span>
                </v-flex>
                <v-flex xs12 py-0>
                  {{l(record.value, record.currency)}}
                  <v-icon class="arrow-icon-small">arrow_forward</v-icon>
                  {{record.exchange_currency}} Operações: {{record.count}}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 py-0 text-xs-right>
              <v-layout row wrap caption>
                <v-flex xs12 py-0>
                  {{longAccountName(record.receiver)}}
                </v-flex>
                <v-flex xs12 py-0>
                  {{longAccountName(record.receiver.intermediary_bank_account)}}
                </v-flex>
              </v-layout>
            </v-flex>

            <transaction @exchange_toogle_selected="handleToogleSelected" :record="transaction" v-for="transaction in transactions" :key="transaction.id" v-if="current_view === 'detailed'" cursor-default/>

            <transition name="fade">
              <v-flex pt-3 xs12 v-if="current_view === 'detailed' && mode === 'normal'" cursor-default>
                <v-layout row wrap body-1>
                  <v-flex xs12 p-0 m-0 v-on:mouseover.stop="" @click.prevent.stop="" :class="{'cursor-default': disableShowExchangeForm}">
                    <v-btn @click="showExchangeForm" block dark class="ma-0 btn-style" :class="{'disable-events': disableShowExchangeForm, 'cursor-default': disableShowExchangeForm}">
                      {{i18n('Realizar Operação de Câmbio')}}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </transition>

            <transition name="fade">
              <v-flex pt-3 xs12 v-if="current_view === 'detailed' && mode === 'confirmation'" cursor-default @click.prevent.stop="">
                <v-layout row wrap body-1>
                  <v-flex xs6 sm3 md2 pr-1>
                    <v-currency-field
                      v-bind="exchange_rate_config"
                      box
                      v-model="spot_exchange_rate"
                      :label="i18n('Taxa de Câmbio Spot')"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs6 sm2 md2 py-0 pr-1>
                    <v-currency-field
                      v-bind="percentage_config"
                      box
                      v-model="iof_rate"
                      label="IOF %"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs6 sm2 md2 py-0 pr-1>
                    <v-currency-field
                      v-bind="percentage_config"
                      box
                      v-model="fx_rate"
                      label="FX %"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm5 md6 pr-1>
                    <v-layout row wrap caption>
                      <v-flex xs12 py-0 text-xs-right v-if="debugMode">
                        Value to exchange: <span class="title" style="color: var(--background-color)">{{calculatedValues.value_to_exchange}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right v-if="debugMode">
                        Value: <span class="title" style="color: var(--background-color)">{{calculatedValues.value}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right v-if="debugMode">
                        Reverse exchange: <span class="title" style="color: var(--background-color)">{{isReverseExchange}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right v-if="debugMode">
                        Withdrawal: <span class="title" style="color: var(--background-color)">{{withdrawal}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right v-if="isReverseExchange">
                        {{i18n('Vender moeda estrangeira')}}: <span class="title" style="color: var(--background-color)">{{l(calculatedValues.value, record.currency)}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right v-if="isReverseExchange">
                       {{i18n('Para pagar')}}: <span class="title" style="color: var(--background-color)">{{l(calculatedValues.value_to_exchange, record.exchange_currency)}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right v-if="!isReverseExchange && !withdrawal">
                        {{i18n('Valor moeda estrangeira')}}: <span class="title" style="color: var(--background-color)">{{l(calculatedValues.value_to_exchange, record.exchange_currency)}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right v-if="!isReverseExchange && withdrawal">
                        {{i18n('Valor moeda nacional')}}: <span class="title" style="color: var(--background-color)">{{l(calculatedValues.value_to_exchange, record.exchange_currency)}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right>
                        {{i18n('Taxa de Câmbio FX (com IOF)')}}: <span class="subheading" style="color: var(--secondary-button-background-color)">{{calculatedValues.fx_exchange_rate_with_iof}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right>
                        {{i18n('Valor FX')}}: <span class="subheading" style="color: var(--secondary-button-background-color)">{{fxValue}}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 md6 pr-1>
                    <v-currency-field
                      box
                      :readonly="true"
                      v-bind="currency_config"
                      v-model="iof_value"
                      :label="i18n('Valor IOF')"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs6 md6 pr-1>
                  </v-flex>
                  <v-flex xs12 md12 pr-1>
                    <v-select
                      box
                      v-model="fromAccountId"
                      :items="fromAccountSelect"
                      :label="fromAccountLabel"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 md6 pa-1 v-on:mouseover.stop="" @click.prevent.stop="" :class="{'cursor-default': disableShowExchangeForm}">
                    <v-btn @click="cancelShowExchangeForm" dark block class="ma-0 secondary-btn-bg-color font-weight-black" :class="{'disable-events': disableShowExchangeForm, 'cursor-default': disableShowExchangeForm}">
                      {{i18n('Cancelar')}}
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 md6 pa-1 v-on:mouseover.stop="" @click.prevent.stop="" :class="{'cursor-default': disableShowExchangeForm}">
                    <v-btn @click="createExchange" block dark class="ma-0 btn-style--secondary font-weight-black" :class="{'disable-events': disableShowExchangeForm, 'cursor-default': disableShowExchangeForm}">
                      {{i18n('Registrar Operação de Câmbio')}}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </transition>

          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-divider />
  </v-flex>
</template>
<script>
import utils from "./shared/Utils"
import TransactionWithScheduleItem from "./TransactionWithScheduleItem"

export default {
  name: 'AdminExchangeAccountItem',
  components: { 'transaction': TransactionWithScheduleItem },
  props: {
    record: {
      type: Object
    },
    bank_accounts: {
      type: Array
    }
  },
  data() {
    return {
      transactions: [],
      company_taxes: {
        fx_rate: {
          default: 1
        },
        iof_rate: 0.38
      },
      received: 0,
      current_view: 'short',
      exchange_rate: 0.0,
      spot_exchange_rate: 0.0,
      iof_rate: 0.38,
      iof_value: 0.0,
      fx_rate: 1,
      fromAccountId: null,
      wireTransactionInfo: '',
      transactionsLoaded: 'not_loaded',
      mode: 'normal',
      submitting_data: false,
      currency_config: {
        decimal: ',',
        thousands: '.',
        precision: 2,
      },
      exchange_rate_config: {
        decimal: ',',
        thousands: '.',
        precision: 5,
      },
      percentage_config: {
        decimal: ',',
        thousands: '.',
        precision: 2,
      },
    }
  },
  computed: {
    debugMode() {
      return this.$route.query.debug ? true : false
    },
    fxValue() {
      if (this.$root.isLocalCurrency(this.record.currency) || this.$root.isCryptoCurrency(this.record.currency)) {
        return (this.calculatedValues.value - (this.calculatedValues.value_to_exchange * this.spot_exchange_rate)).toFixed(2)
      } else {
        return ((this.calculatedValues.value * this.spot_exchange_rate) - this.calculatedValues.value_to_exchange).toFixed(2)
      }
    },
    isReverseExchange() {
      return (Number(this.reverseCalculatedValues.value_from_exchange) > 0.0)
    },
    withdrawal() {
      if (this.$root.isLocalCurrency(this.record.exchange_currency) || this.$root.isCryptoCurrency(this.record.exchange_currency)) {
        return true
      }
      return false
    },
    calculatedValues() {
      let result = {}
      if (this.isReverseExchange) {
        result = {
          value_to_exchange: this.reverseCalculatedValues.value,
          fx_exchange_rate_with_iof: this.reverseCalculatedValues.fx_exchange_rate_with_iof,
          value: this.reverseCalculatedValues.value_from_exchange
        }
      } else {
        result = {
          value_to_exchange: this.regularCalculatedValues.value_to_exchange,
          fx_exchange_rate_with_iof: this.regularCalculatedValues.fx_exchange_rate_with_iof,
          value: this.regularCalculatedValues.value
        }
      }

      if (result.value > 0) {
        if (this.$root.isLocalCurrency(this.record.currency) || this.$root.isCryptoCurrency(this.record.currency)) {
          this.$set(this, 'iof_value', ((result.value) * (this.iof_rate / 100.0)).toFixed(2))
        } else {
          let local_value = result.value * this.spot_exchange_rate
          this.$set(this, 'iof_value', ((local_value) * (this.iof_rate / 100.0)).toFixed(2))
        }
      } else {
        this.$set(this, 'iof_value', 0.0)
      }

      return result
    },
    regularCalculatedValues() {
      let value_to_exchange = 0
      let value_from_exchange = 0
      let fx_exchange_rate_with_iof = 0
      let fx_rate = this.fx_rate / 100.0
      let iof_rate = this.iof_rate / 100.0
      let exchange_rate = this.spot_exchange_rate
      let value = this.selectedTransactions.reduce( ( acc, record ) => { return (record.estimated_value_until_exchange === true) ? acc : acc + (record.value * 1.0) }, 0 )
      let number_of_transactions = this.selectedTransactions.length

      if (this.$root.isLocalCurrency(this.record.currency) || this.$root.isCryptoCurrency(this.record.currency)) {
        let fx_exchange_rate = (exchange_rate * (1 + fx_rate))
        fx_exchange_rate_with_iof = (fx_exchange_rate * (1 + iof_rate)).toFixed(5)
        let value_without_taxes = value
        if (exchange_rate > 0) {
          value_to_exchange = (value_without_taxes / fx_exchange_rate_with_iof).toFixed(2)
        }
      } else {
        let fx_exchange_rate = (exchange_rate * (1 - fx_rate))
        fx_exchange_rate_with_iof = (fx_exchange_rate * (1 - iof_rate)).toFixed(5)
        if (exchange_rate > 0) {
          value_to_exchange = ((value * fx_exchange_rate_with_iof)).toFixed(2)
        }
      }

      return {
        value_to_exchange: value_to_exchange,
        fx_exchange_rate_with_iof: fx_exchange_rate_with_iof,
        value: value
      }
    },
    reverseCalculatedValues() {
      let value_to_exchange = 0
      let value_from_exchange = 0
      let fx_exchange_rate_with_iof = 0
      let fx_rate = this.fx_rate / 100.0
      let iof_rate = this.iof_rate / 100.0
      let exchange_rate = this.spot_exchange_rate
      let value = this.selectedTransactions.reduce( ( acc, record ) => { return (record.estimated_value_until_exchange === true) ? acc + (record.exchanged_value * 1.0): acc }, 0 )
      let number_of_transactions = this.selectedTransactions.length

      if (this.$root.isLocalCurrency(this.record.currency)) {
        let fx_exchange_rate = (exchange_rate * (1 + fx_rate))
        fx_exchange_rate_with_iof = (fx_exchange_rate * (1 + iof_rate)).toFixed(5)
        if (exchange_rate > 0) {
          value_from_exchange = ((value * fx_exchange_rate_with_iof)).toFixed(2)
        }
      } else {
        let fx_exchange_rate = (exchange_rate * (1 - fx_rate))
        fx_exchange_rate_with_iof = (fx_exchange_rate * (1 - iof_rate)).toFixed(5)
        let value_with_taxes = (value)
        if (exchange_rate > 0) {
          value_from_exchange = (value_with_taxes / fx_exchange_rate_with_iof).toFixed(2)
        }
      }

      if (value == 0.0) {
        return {
          value_from_exchange: '0.00',
          value: 0.0,
          fx_exchange_rate_with_iof: fx_exchange_rate_with_iof,
        }
      }

      return {
        value_from_exchange: value_from_exchange,
        value: value,
        fx_exchange_rate_with_iof: fx_exchange_rate_with_iof
      }
    },
    disableShowExchangeForm() {
      return this.selectedTransactions.length == 0
    },
    disableCreateExchange() {
      return this.selectedTransactions.length == 0
    },
    selectedTransactions() {
      return this.transactions.filter( ( record ) => { return record.selected } )
    },
    fromAccountSelect() {
      return this.accountSelect(this.record.currency)
    },
    fromAccountLabel() {
      return `Conta ${this.record.currency}`
    },
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    toogleView() {
      if (this.current_view === 'short') {
        this.loadExchangeRate()
      }
      this.current_view = (this.current_view === 'short') ? 'detailed' : 'short'
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    },
    shortBankName(account) {
      return utils.shortBankName(account)
    },
    longAccountName(account) {
      if (account === null) { return '' }
      return utils.longAccountName(account)
    },
    accountSelect(currency) {
      let bank_accounts = this.bank_accounts.filter( ( record ) => { return record.currency == currency } )
      return bank_accounts.map(o => { return {text: utils.shortAccountName(o), value: `${o.id}`} })
    },
    loadTransactions() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.transactions = response.body.data.map(o => {
            o.selected = true;
            return o;
          })
          this.transactionsLoaded = 'ok'
        } else {
          this.transactionsLoaded = 'error'
          console.log('successCallback', response)
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.transactionsLoaded = 'not_authorized'
        } else {
          this.transactionsLoaded = 'error'
        }
      }

      this.transactionsLoaded = 'not_loaded'
      let token = this.$cookies.get('api_token')
      const payload = { bank_transaction_ids: this.record.bank_transaction_ids }
      let url = this.$root.urls.admin__load_bank_transactions
      this.$http.post(url, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    loadCompanyTaxes() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.company_taxes = response.body.data
          if (this.$root.isLocalCurrency(this.record.currency)) {
            this.iof_rate = this.company_taxes.iof_rate.value * 1
          } else {
            this.iof_rate = this.company_taxes.sell_iof_rate.value * 1
          }
          this.fx_rate = this.company_taxes.fx_rate * 1
        }
      }

      let errorCallback = (response) => {
        if (response.body.error == 'CompanyTaxes not registered') {
          return true
        }
      }

      let token = this.$cookies.get('api_token')
      let url = this.$root.urls.admin__company_taxes.split('ID').join(this.record.company_id)
      let params = {currency: this.record.currency, exchange_currency: this.record.exchange_currency, for_bank_account_id: this.record.receiver.id, operation_value: '0.0'}

      this.$http.get(url, { params: params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    loadExchangeRate() {
      let successCallback = (response) => {
        let exchange_rate = this.record.currency.toLowerCase() + this.record.exchange_currency.toLowerCase()
        let exchange_rate_reverse = this.record.exchange_currency.toLowerCase() + this.record.currency.toLowerCase()

        Object.keys(response.body.data).forEach((key) => {
          if (key == exchange_rate) {
            this.exchange_rate = Number(response.body.data[key])
            this.spot_exchange_rate = Number(response.body.data[key + 'spot']) ? Number(response.body.data[key + 'spot']) : Number(response.body.data[exchange_rate_reverse + 'spot'])
          }
        });
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
      }

      let token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.exchange_rates, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    cancelShowExchangeForm() {
      this.mode = 'normal'
    },
    showExchangeForm() {
      if (this.disableShowExchangeForm) return null

      if (this.mode == 'normal') {
        this.mode = 'confirmation'
        return null
      } else {
        this.mode = 'creating'
      }
    },
    createExchange() {
      if (this.disableCreateExchange) { return }
      if (this.submitting_data) { return }

      let successCallback = (response) => {
        console.log('successCallback', response)
        if (response.body.data) {
          this.$emit('exchangeCreated', this.record, response.body.data)
        }
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
        this.submitting_data = false
      }

      const transactionIds = this.selectedTransactions.map(t => { return t.id })

      const payload = {
        exchange: {
          currency: this.record.currency,
          exchange_currency: this.record.exchange_currency,
          exchange_rate: this.calculatedValues.fx_exchange_rate_with_iof,
          exchange_rate_spot: this.spot_exchange_rate,
          value: this.calculatedValues.value,
          exchanged_value: this.calculatedValues.value_to_exchange,
          iof_rate: String(this.iof_rate / 100.0),
          iof_value: this.iof_value,
          fx_rate: String(this.fx_rate / 100.0),
          fx_value: this.fxValue,
          from_bank_account_id: this.fromAccountId,
          to_bank_account_id: this.record.receiver.id,
          bank_transaction_ids: transactionIds
        }
      }

      this.submitting_data = true
      let token = this.$cookies.get('api_token')
      let url = this.$root.urls.admin_exchanges
      this.$http.post(url, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    handleToogleSelected(item) {
      for (let index in this.transactions) {
        if (this.transactions[index].id === item.id) {
          this.$set(this.transactions[index], 'selected', !item.selected)
        }
      }
    },
    receiverName(receiver) {
      if (receiver.owner_name) return receiver.owner_name
      if (receiver.company && receiver.company.social_name) return receiver.company.social_name
      return ''
    }
  },
  mounted() {
    this.loadTransactions()
    this.loadCompanyTaxes()
    if (this.fromAccountSelect[0]) {
      this.fromAccountId = this.fromAccountSelect[0].value
    }
  }
}
</script>
<style>
  .adjust-btn-top-margin {
    margin-top: -28px;
  }
  .disable-events {
    pointer-events: none;
  }
  .cursor-default {
    cursor: default!important;
  }
  .secondary-btn-bg-color{
    color: var(--background-color)!important;
    background-color: rgba(0,0,0,.10)!important;
    height: 56px;
  }
</style>



// WEBPACK FOOTER //
// src/AdminExchangeAccountItem.vue